import logo from '@/assets/images/logo.svg';

import { cn } from '@/lib/utils';

interface LogoProps {
    text?: string;
    hideText?: boolean;
    className?: string;
    textClassName?: string;
    imageClassName?: string;
}

const Logo = ({
    text = 'SOJI',
    hideText = false,
    className,
    textClassName,
    imageClassName,
}: LogoProps) => {
    return (
        <div
            className={cn('flex items-center gap-2 text-slate-900', className)}
        >
            <img
                width={32}
                height={32}
                alt="logo"
                src={logo}
                className={cn('h-8 w-8', imageClassName)}
            />
            {!hideText && (
                <div
                    className={cn(
                        'text-2xl font-sans font-semibold tracking-tight',
                        textClassName,
                    )}
                >
                    {text}
                </div>
            )}
        </div>
    );
};

export default Logo;
